module.exports = __webpack_public_path__ + "static/media/quick-setup-image-latest.13370dc3.png";